export var detail = '/api/myy/article/detail'//{get:{id->('')}}
export var list = '/api/myy/article/list'//{get:{page->(\d+):articleType->(0,1)}}
export var banner = '/api/myy/banner/list'//{get:{type->(0,1,2)}}
export var activity_list = '/api/myy/activity/list'//{get:{}}
export var weixin = '/wx/js/get-jssdksign'//{get:{href}}

//获取频道列表
export var get_channel_list = "api/myy/article/channel-list"; // {get:{}}
//通过表单id，获取表单定义，字段定义见线索系统接口文档
export var get_activity_form = '/api/myy/ekp-clue/get-activity-form';//{get:{activity_id ->('')}}
export var get_activity_form_v2 = '/adminapi/myy/common/get-activity-form-v2';
//保存表单信息
export var save_activity_form = "/api/myy/ekp-clue/save-activity-form";//
export var save_activity_form_v2 = "/adminapi/myy/common/save-activity-form-v2";//
export var get_activity_result_qr_code = "/wxapp/common/get-clue-qr-code";
//获取验证码
export var send_sms = "/wx/membership/send-sms"; //{get:{mobile -> ('')}}
export var send_sms_v2 = "/adminapi/myy/common/send-sms"; //{get:{mobile -> ('')}}
// 搜索公司联想查询
export var get_company_list = "https://api.mingyuanyun.com/api/SupplierApi/GetSupplierEnterpriseInformation";


// WEBPACK FOOTER //
// ./src/api/api.js